export default __webpack_public_path__ + "static/media/Chubs.d87c432f.woff";